<template>
  <v-toolbar
    flat
    dark
    color="secondary"
    max-height="56"
  >
    <v-btn
      icon
      :color="editable ? 'white' : 'primary'"
      :disabled="loading || closing || locked"
      @click="cancelTpvAndClose()"
    >
      <v-icon
        :large="editable"
        v-text="editable ? icons.prev : icons.close"
      />
    </v-btn>
    <h-numeric-menu
      v-model="seats"
      :title="__('guests')"
      display="10"
      :disabled="! editable"
    >
      <template #activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          outlined
          :icon="order.guests <= 99"
          :rounded="order.guests > 99"
          small
          color="primary"
          v-text="order.guests"
          class="ml-1 mr-4"
          :disabled="! editable"
        />
      </template>
    </h-numeric-menu>
    <v-toolbar-title v-text="order.tableName" />
    <v-spacer />
    <v-btn
      v-if="editable"
      icon
      :disabled="locked"
      @click.stop="openCatalog()"
    >
      <v-icon v-text="icons.plusCircle" />
    </v-btn>
    <v-btn
      v-else
      icon
      :loading="loading || reloading"
      @click="reload()"
    >
      <v-icon v-text="icons.reload" />
    </v-btn>
  </v-toolbar>
</template>

<script>
  import { mapState } from 'vuex'
  import ActivatesClickBlocker from '@/Mixins/ActivatesClickBlocker'
  import I18n from '@/Mixins/I18n'
  import InteractsWithLoading from '@/Mixins/InteractsWithLoading'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HNumericMenu from '@/Components/NumericMenu'

  export default {
    mixins: [
      ActivatesClickBlocker,
      I18n,
      InteractsWithLoading,
      UsesIcons,
    ],

    components: {
      HNumericMenu,
    },

    props: {
      editable: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      reloading: false,
      closing: false,
    }),

    computed: {
      ...mapState('orders', {
        order: 'current',
      }),
      ...mapState('orders/dialogs', [
        'locked',
      ]),
      ...mapState('workingModes', {
        tpvMode: 'tpv',
      }),
      seats: {
        get () {
          return this.order.guests
        },
        set (v) {
          this.$store.commit('orders/changeSeats', v)
        }
      },
    },

    methods: {
      openCatalog () {
        this.activateClickBlocker(() => {
          this.$store.dispatch('orders/dialogs/openCatalog')
        }, 0)
      },
      reload () {
        // Capture orderId in local variable to prevent race condition
        const orderId = this.order.id
        
        this.reloading = true
        this.$log('Reloading...', 'Order', orderId)
        this.$api('getOrder', {id: orderId})
          .then(r => {
            this.$log('Reloaded', 'Order', orderId)
            
            // Only update if we're still viewing the same order
            if (this.order.id === orderId) {
              this.$store.commit('orders/current', r.data?.order)
            } else {
              this.$log('Order changed during reload, ignoring result', 'Order', orderId)
            }
          })
          .catch(e => this.$store.dispatch('xError', e))
          .finally(() => this.reloading = false)
      },
      cancelTpvAndClose () {
        if (this.closing) {
          return
        }

        if (this.tpvMode && ! this.order.isEmpty) {
          this.$store.dispatch('alert/showWarning', this.__('exitTpvError'))
          return
        }

        this.closing = true
        setTimeout(() => this.closing = false, 400)
        this.$store.commit('workingModes/disableTpvMode')
        this.$store.commit('sync/skip', false)
        this.$emit('close')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .theme--dark.v-btn.v-btn--disabled {
    color: white !important;
  }
</style>
